<script>
/* global axios */
// Diálogo de editar mensagem (Evolution): altera o texto de uma mensagem já
// enviada via /chat/updateMessage do provedor. Só para caixas de provedor.
import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: { NextButton },
  props: {
    message: { type: Object, required: true },
  },
  emits: ['close', 'edited'],
  data() {
    return { content: '', saving: false };
  },
  computed: {
    ...mapGetters({ accountId: 'getCurrentAccountId' }),
  },
  mounted() {
    this.content = this.message?.content || '';
  },
  methods: {
    async submit() {
      if (!this.content.trim()) return;
      this.saving = true;
      try {
        await axios.patch(
          `/api/v1/accounts/${this.accountId}/kanban/edit_messages/${this.message.id}`,
          { content: this.content.trim() }
        );
        useAlert(this.$t('CONVERSATION.EDIT_MESSAGE.SUCCESS'));
        this.$emit('edited', this.content.trim());
        this.$emit('close');
      } catch (e) {
        useAlert(
          e?.response?.data?.error || this.$t('CONVERSATION.EDIT_MESSAGE.ERROR')
        );
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<template>
  <div
    class="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-n-alpha-black2"
    @click.self="$emit('close')"
  >
    <div class="w-[28rem] max-w-full p-6 bg-n-background rounded-xl shadow-xl">
      <h2 class="mb-3 text-base font-medium text-n-slate-12">
        {{ $t('CONVERSATION.EDIT_MESSAGE.TITLE') }}
      </h2>
      <textarea
        v-model="content"
        rows="4"
        class="w-full px-3 py-2 text-sm border rounded-lg resize-none border-n-weak bg-n-alpha-1 text-n-slate-12"
      />
      <div class="flex justify-end gap-2 mt-4">
        <NextButton
          slate
          faded
          sm
          :label="$t('CONVERSATION.EDIT_MESSAGE.CANCEL')"
          @click="$emit('close')"
        />
        <NextButton
          blue
          sm
          :is-loading="saving"
          :label="$t('CONVERSATION.EDIT_MESSAGE.SUBMIT')"
          @click="submit"
        />
      </div>
    </div>
  </div>
</template>
